/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { classes } from 'istanbul-lib-coverage';
import BaseStepper from '../../Common/BaseStepper';
import BackContinueButton from '../../Common/BackContinueButton';

import { formValidator, removeSpecialCharacters } from '../../../AppUtil/AppUtil';
import Session from '../../../Service/Session';
import MaskedInputField from '../MaskedInputField';
import { withTranslation } from 'react-i18next';
import UserService from '../../../Service/UserService';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

const styles = theme => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 250
	}
});

class OthersInfo extends Component {
	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			_selfInviteError: '',
			disabled: true,
			supportedRelationships: this.props.supportedRelationships,
			labelWidth: 0,
			_othersInfoForm: {
				emailId: {
					value: '',
					placeholder: 'label.email',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: false,
							errorMsg: 'error_message.field_required'
						},
						pattern: {
							value: PATTERN.EMAIL,
							errorMsg: 'error_message.invalid_email'
						}
					},
					error_text: ''
				},
				name: {
					value: '',
					placeholder: 'label.name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.field_required'
						},
						pattern: {
							value: PATTERN.FULL_NAME,
							errorMsg: 'error_message.invalid_full_name'
						}
					},
					error_text: ''
				},
				countryCode: {
					value: '+63'
				},
				phone: {
					value: '',
					placeholder: 'label.contact',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: false,
							errorMsg: 'error_message.field_required'
						},
						pattern: {
							value: PATTERN.CONTACT,
							errorMsg: 'error_message.invalid_contact'
						}
					},
					error_text: ''
				},
				relationship: {
					value: null,
					placeholder: 'label.relationship',
					valid: false,
					touched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.select_required'
						}
					},
					error_text: ''
				}
			}
		};
	}

	setDefaultValue = () => {
		if (this.props.initOtherInfo.name !== '') {
			const otherInfoForm = { ...this.state._othersInfoForm };
			const initialForm = this.props.initOtherInfo;
			otherInfoForm.name.value = initialForm.name;
			otherInfoForm.phone.value = initialForm.phone.replace(/^3+/, '');

			otherInfoForm.countryCode.value = initialForm.countryCode;
			otherInfoForm.emailId.value = initialForm.emailId;
			otherInfoForm.relationship.value = initialForm.relationship;
			this.setState({
				_othersInfoForm: otherInfoForm,
				disabled: false
			});
		}
	};

	handelInputChange = e => {
		// NOSONAR
		const name = e.target.name;
		let value = e.target.value;

		this.setState({
			_selfInviteError: ''
		});
		const infoForm = {
			...this.state._othersInfoForm
		};
		const updatedFormElement = {
			...infoForm[name]
		};

		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		infoForm[name] = updatedFormElement;
		this.setState({
			_othersInfoForm: infoForm
		});

		if (
			this.state._othersInfoForm.emailId.value !== '' &&
			this.state._othersInfoForm.relationship.value !== null &&
			name === 'name' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.emailId.value !== '' &&
			this.state._othersInfoForm.name.value !== '' &&
			name === 'relationship' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.phone.value !== '' &&
			this.state._othersInfoForm.relationship.value !== null &&
			name === 'name' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.phone.value !== '' &&
			this.state._othersInfoForm.name.value !== '' &&
			name === 'relationship' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.relationship.value !== null &&
			this.state._othersInfoForm.name.value !== '' &&
			name === 'emailId' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.relationship.value !== null &&
			this.state._othersInfoForm.name.value !== '' &&
			name === 'phone' &&
			value !== ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.relationship.value !== null &&
			this.state._othersInfoForm.name.value !== '' &&
			this.state._othersInfoForm.emailId.value !== '' &&
			name === 'phone' &&
			value === ''
		) {
			this.setState({ disabled: false });
		} else if (
			this.state._othersInfoForm.relationship.value !== null &&
			this.state._othersInfoForm.name.value !== '' &&
			this.state._othersInfoForm.phone.value !== '' &&
			name === 'emailId' &&
			value === ''
		) {
			this.setState({ disabled: false });
		} else {
			this.setState({
				disabled: true
			});
		}
	};

	// checkIfPhoneExist = async phone => {
	// 	let input_phone = `${6}${phone}`;
	// 	const res = await UserService.getUserByPhone(input_phone);
	// 	if (res === 'No DATA found in Database') {
	// 		return false;
	// 	} else {
	// 		return true;
	// 	}
	// };

	formatPhoneInput = phone => {
		let format_phone_input = `${phone.replace(/[- )(]/g, '')}`;

		if (Number(format_phone_input.charAt(0)) !== 3) {
			return (format_phone_input = `${phone.replace(/[- )(]/g, '')}`);
		}

		return format_phone_input;
	};

	onSubmitToDetailScreen = async otherInfo => {
		const selfInfo = this.props.userDetails.created_by_user;

		// const phoneExist = await this.checkIfPhoneExist(this.formatPhoneInput(this.state._othersInfoForm.phone.value));
		const otherInfoPhone = this.formatPhoneInput(otherInfo.countryCode + otherInfo.phone);
		console.log(otherInfoPhone);

		if (this.props.flow === 'BORROW') {
			if (
				// 	this.state._othersInfoForm.phone.value === this.props.initOtherInfo.phone ||
				// 	this.formatPhoneInput(this.state._othersInfoForm.phone.value) === this.props.initOtherInfo.phone ||
				// 	this.state._othersInfoForm.emailId.value === this.props.initOtherInfo.emailId ||
				// 	this.state._othersInfoForm.name.value === this.props.initOtherInfo.name ||
				!this.state._othersInfoForm.phone.value ||
				!this.state._othersInfoForm.emailId.value
			) {
				this.setState({
					_selfInviteError: 'Please fill up the empty field.'
				});
			}
			// } else if (!phoneExist) {
			// 	this.setState({ _selfInviteError: 'User not registered with the specified phone number!' });
			else {
				if (otherInfo.emailId === selfInfo.email || otherInfoPhone === selfInfo.phone) {
					this.setState({ _selfInviteError: 'error_message.invalid_self_invite' });
				} else {
					this.props.onSubmitDetail(this.state._othersInfoForm);
				}
			}
		}
		if (this.props.flow === 'LEND') {
			if (
				// 	this.state._othersInfoForm.phone.value === this.props.initOtherInfo.phone ||
				// 	this.formatPhoneInput(this.state._othersInfoForm.phone.value) === this.props.initOtherInfo.phone ||
				// 	this.state._othersInfoForm.emailId.value === this.props.initOtherInfo.emailId ||
				// 	this.state._othersInfoForm.name.value === this.props.initOtherInfo.name ||
				!this.state._othersInfoForm.phone.value ||
				!this.state._othersInfoForm.emailId.value
			) {
				this.setState({
					_selfInviteError: 'Please fill up the empty field.'
				});
				// } else if (!phoneExist) {
				// 	this.setState({ _selfInviteError: 'User not registered with the specified phone number!' });
			} else {
				if (otherInfo.emailId === selfInfo.email || otherInfoPhone === selfInfo.phone) {
					this.setState({ _selfInviteError: 'error_message.invalid_self_invite' });
				} else {
					this.props.onSubmitDetail(this.state._othersInfoForm);
				}
			}
		}
	};

	/**
	 * This function handle submit login form
	 * @returns {Promise<void>}
	 */
	validate = async e => {
		e.preventDefault();
		if (!this.props.fromDetails) {
			if (!this.formValidator()) {
				return false;
			}
		}

		const other_info = {
			name: this.state._othersInfoForm.name.value,
			relationship: this.state._othersInfoForm.relationship.value,
			emailId: this.state._othersInfoForm.emailId.value,
			phone: this.state._othersInfoForm.phone.value,

			countryCode: this.state._othersInfoForm.countryCode.value
		};
		if (this.props.fromDetails) {
			this.onSubmitToDetailScreen(other_info);
		} else {
			this.props.onContinue(other_info);
		}
	};

	/**
	 * This function validate all field in login form
	 */
	formValidator = () => {
		const form = {
			...this.state._othersInfoForm
		};
		const loanObject = Session.get('LOAN_OBJECT');
		let [updatedForm, isFormValid] = formValidator(form);
		if (form.phone.value === '' && form.emailId.value === '') {
			isFormValid = false;
			this.setState({ _selfInviteError: 'error_message.either_entry_required' });
		}
		if (form.emailId.value === loanObject.self_info.emailId || form.phone.value === loanObject.self_info.phone) {
			isFormValid = false;
			this.setState({ _selfInviteError: 'error_message.invalid_self_invite' });
		}
		this.setState({
			_othersInfoForm: updatedForm
		});
		return isFormValid;
	};

	setLabelWidth = () => {
		this.setState({
			labelWidth: this.inputLabel.current.offsetWidth
		});
	};

	onCountryCodeSelect = e => {
		const infoForm = { ...this.state._othersInfoForm };

		infoForm.countryCode.value = e.target.value;

		this.setState({
			_othersInfoForm: infoForm
		});
	};

	// sliceCountryCode = code => {
	// 	if (code.charAt(1) === '9') {
	// 		return '+91';
	// 	} else if (code.charAt(1) === '3') {
	// 		return '+34';
	// 	} else if (code.charAt(1) === '4') {
	// 		return '+44';
	// 	}
	// 	} else {
	// 		return '+63';
	// 	}
	// };

	// slicePhoneNumber = phone => {
	// 	return phone.charAt(1) === '1' ? phone.slice(2) : phone.slice(3);
	// };

	componentDidMount() {
		this.setLabelWidth();
	}

	handleRelationshipChange = event => {
		this.handelInputChange({ target: { name: 'relationship', value: event.target.value } });
	};

	componentDidUpdate(nextProps) {
		if (nextProps.initOtherInfo !== this.props.initOtherInfo) {
			this.setDefaultValue();
		}
	}

	render() {
		const { t } = this.props;

		return (
			<BaseStepper
				buttons={
					<BackContinueButton
						countinueButtonText={this.props.fromDetails ? 'save' : 'continue'}
						isDisabled={this.state.disabled}
						onBack={this.props.handleBack}
						onContinue={this.validate}
					/>
				}
				heading={this.props.heading}>
				<div className="mdl-cell mdl-cell--10-col ">
					<form className="text-center" id="otherinfoform">
						<TextField
							error={
								!this.state._othersInfoForm.name.isValid && this.state._othersInfoForm.name.isTouched
							}
							fullWidth
							helperText={
								!this.state._othersInfoForm.name.isValid && this.state._othersInfoForm.name.isTouched
									? t(this.state._othersInfoForm.name.error_text)
									: ''
							}
							id="outlined-basic"
							label={t(this.state._othersInfoForm.name.placeholder)}
							name="name"
							onChange={this.handelInputChange}
							value={this.state._othersInfoForm.name.value || ''}
							variant="outlined"
						/>
						<FormControl className={classes.formControl} fullWidth variant="outlined">
							<InputLabel id="demo-simple-select-outlined-label" ref={this.inputLabel}>
								{t(this.state._othersInfoForm.relationship.placeholder)}
							</InputLabel>
							<Select
								className="text-align-start relationship"
								error={
									!this.state._othersInfoForm.relationship.isValid &&
									this.state._othersInfoForm.relationship.isTouched
								}
								fullWidth
								id="demo-simple-select-outlined"
								labelId="demo-simple-select-outlined-label"
								labelWidth={this.state.labelWidth}
								onChange={this.handleRelationshipChange}
								value={this.state._othersInfoForm.relationship.value || ''}>
								{this.state.supportedRelationships.map((relation, index) => (
									<MenuItem key={index} value={relation.value}>
										{t(`label.${relation.label}`)}
									</MenuItem>
								))}
							</Select>
						</FormControl>
						<InputLabel />
						<Grid container justify="center" spacing={0}>
							<Grid item sm={2} xs={3}>
								<FormControl variant="outlined">
									<InputLabel id="demo-simple-select-outlined-label" />
									<Select
										className="width-98-p"
										fullWidth
										id="demo-simple-select-outlined"
										labelId="demo-simple-select-outlined-label"
										labelWidth={0}
										onChange={this.onCountryCodeSelect}
										value={this.state._othersInfoForm.countryCode.value}>
										<MenuItem value="+91">+91</MenuItem>
										<MenuItem value="+63">+63</MenuItem>
										<MenuItem value="+44">+44</MenuItem>
										<MenuItem value="+34">+34</MenuItem>
									</Select>
								</FormControl>
							</Grid>
							<Grid item sm={10} xs={9}>
								<MaskedInputField
									error={
										!this.state._othersInfoForm.phone.isValid &&
										this.state._othersInfoForm.phone.isTouched
									}
									error_text={t(this.state._othersInfoForm.phone.error_text)}
									handleChange={this.handelInputChange}
									label={t(this.state._othersInfoForm.phone.placeholder)}
									value={this.state._othersInfoForm.phone.value}
								/>
							</Grid>
						</Grid>
						<TextField
							error={
								!this.state._othersInfoForm.emailId.isValid &&
								this.state._othersInfoForm.emailId.isTouched
							}
							fullWidth
							helperText={
								!this.state._othersInfoForm.emailId.isValid &&
								this.state._othersInfoForm.emailId.isTouched
									? t(this.state._othersInfoForm.emailId.error_text)
									: ''
							}
							id="outlined-basic"
							label={t(this.state._othersInfoForm.emailId.placeholder)}
							name="emailId"
							onChange={this.handelInputChange}
							value={this.state._othersInfoForm.emailId.value || ''}
							variant="outlined"
						/>
						<FormHelperText id="text-red">{t(this.state._selfInviteError)}</FormHelperText>
					</form>
				</div>
			</BaseStepper>
		);
	}
}

export default withTranslation(['Core'])(withStyles(styles)(OthersInfo));
